import styles from "./LetterTile.module.css";

export type LetterTileState = "pending" | "current" | "done" | "miss";

interface LetterTileProps {
  char: string;
  state: LetterTileState;
  size?: "md" | "sm";
  onClick?: () => void;
  pressed?: boolean;
}

export default function LetterTile({ char, state, size = "md", onClick, pressed }: LetterTileProps) {
  const upper = char.toUpperCase();
  const cls = `${styles.tile} ${styles[state]} ${styles[size]}`;
  if (onClick) {
    return (
      <button type="button" className={cls} onClick={onClick} aria-pressed={pressed} aria-label={`${upper}, ${state}`}>
        {upper}
      </button>
    );
  }
  return (
    <span className={cls} aria-label={`${upper}, ${state}`}>
      {upper}
    </span>
  );
}
